if (!Object.keys) {
  Object.keys = function(obj) {
    var keys = [];

    for (var i in obj) {
      if (obj.hasOwnProperty(i)) {
        keys.push(i);
      }
    }

    return keys;
  };
}

Object.resolve = function(path, obj, safe) {
    return path.split('.').reduce(function(prev, curr) {
        return !safe ? prev[curr] : (prev ? prev[curr] : undefined)
    }, obj || self)
}

Array.prototype.unique = function() {
    var a = this.concat();
    for(var i=0; i<a.length; ++i) {
        for(var j=i+1; j<a.length; ++j) {
            if(a[i] === a[j])
                a.splice(j, 1);
        }
    }
    return a;
};
Array.prototype.getUnique = function(){
   var u = {}, a = [];
   for(var i = 0, l = this.length; i < l; ++i){
      if(u.hasOwnProperty(this[i])) {
         continue;
      }
      a.push(this[i]);
      u[this[i]] = 1;
   }
   return a;
}
if (!Array.prototype.filter) {
  Array.prototype.filter = function(fun/*, thisArg*/) {
    'use strict';

    if (this === void 0 || this === null) {
      throw new TypeError();
    }

    var t = Object(this);
    var len = t.length >>> 0;
    if (typeof fun !== 'function') {
      throw new TypeError();
    }

    var res = [];
    var thisArg = arguments.length >= 2 ? arguments[1] : void 0;
    for (var i = 0; i < len; i++) {
      if (i in t) {
        var val = t[i];

        // NOTE: Technically this should Object.defineProperty at
        //       the next index, as push can be affected by
        //       properties on Object.prototype and Array.prototype.
        //       But that method's new, and collisions should be
        //       rare, so use the more-compatible alternative.
        if (fun.call(thisArg, val, i, t)) {
          res.push(val);
        }
      }
    }

    return res;
  };
}

if (!Array.prototype.map) {

  Array.prototype.map = function(callback, thisArg) {

    var T, A, k;

    if (this == null) {
      throw new TypeError(' this is null or not defined');
    }

    // 1. Let O be the result of calling ToObject passing the |this|
    //    value as the argument.
    var O = Object(this);

    // 2. Let lenValue be the result of calling the Get internal
    //    method of O with the argument "length".
    // 3. Let len be ToUint32(lenValue).
    var len = O.length >>> 0;

    // 4. If IsCallable(callback) is false, throw a TypeError exception.
    // See: http://es5.github.com/#x9.11
    if (typeof callback !== 'function') {
      throw new TypeError(callback + ' is not a function');
    }

    // 5. If thisArg was supplied, let T be thisArg; else let T be undefined.
    if (arguments.length > 1) {
      T = thisArg;
    }

    // 6. Let A be a new array created as if by the expression new Array(len)
    //    where Array is the standard built-in constructor with that name and
    //    len is the value of len.
    A = new Array(len);

    // 7. Let k be 0
    k = 0;

    // 8. Repeat, while k < len
    while (k < len) {

      var kValue, mappedValue;

      // a. Let Pk be ToString(k).
      //   This is implicit for LHS operands of the in operator
      // b. Let kPresent be the result of calling the HasProperty internal
      //    method of O with argument Pk.
      //   This step can be combined with c
      // c. If kPresent is true, then
      if (k in O) {

        // i. Let kValue be the result of calling the Get internal
        //    method of O with argument Pk.
        kValue = O[k];

        // ii. Let mappedValue be the result of calling the Call internal
        //     method of callback with T as the this value and argument
        //     list containing kValue, k, and O.
        mappedValue = callback.call(T, kValue, k, O);

        // iii. Call the DefineOwnProperty internal method of A with arguments
        // Pk, Property Descriptor
        // { Value: mappedValue,
        //   Writable: true,
        //   Enumerable: true,
        //   Configurable: true },
        // and false.

        // In browsers that support Object.defineProperty, use the following:
        // Object.defineProperty(A, k, {
        //   value: mappedValue,
        //   writable: true,
        //   enumerable: true,
        //   configurable: true
        // });

        // For best browser support, use the following:
        A[k] = mappedValue;
      }
      // d. Increase k by 1.
      k++;
    }

    // 9. return A
    return A;
  };
}
Array.prototype.search = function(key, prop){
    for (var i=0; i < this.length; i++) {
        if (this[i][prop] === key) {
            return this[i];
        }
    }
}

if (!Array.isArray) {
  Array.isArray = function(arg) {
    return Object.prototype.toString.call(arg) === '[object Array]';
  };
}

Array.prototype.sum = Array.prototype.sum || function() {
  return this.reduce(function(sum, a) { return sum + Number(a) }, 0);
}

function toTitleCase(str)
{
  if(str){
    return str.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
  }
}

Array.prototype.average = Array.prototype.average || function() {
  return this.sum() / (this.length || 1);
}

function objectsAreSame(a, b) {
    // Create arrays of property names
    var aProps = Object.getOwnPropertyNames(a);
    var bProps = Object.getOwnPropertyNames(b);

    // If number of properties is different,
    // objects are not equivalent
    if (aProps.length != bProps.length) {
        return false;
    }

    for (var i = 0; i < aProps.length; i++) {
        var propName = aProps[i];

        // If values of same property are not equal,
        // objects are not equivalent
        if (a[propName] !== b[propName]) {
            return false;
        }
    }

    // If we made it this far, objects
    // are considered equivalent
    return true;
}

function arrayChanges(previous, current, options, adjustedTotals){ //assuming objects, both containing a average key
  adjustedTotals = (adjustedTotals != undefined ? adjustedTotals : false);
  var _changes = [];
  var totalInCurrent = 0;
  for(var key in previous){
    if(key in current){
      var change,
        changePercent,
        changeType,
        adjustedPercent;
      totalInCurrent += current[key].average;
      change = current[key].average - previous[key].average;
      if(change != 0){
        changeType = (change > 0 ? options.changeType.increased : options.changeType.decreased);
        changePercent = (change / previous[key].average) * 100;
      }
      else{
        changeType = 'same';
        change = current[key].average;
        changePercent = 100;
      }
      if(adjustedTotals !== false){
        adjustedPercent = (current[key].average / adjustedTotals['current']) - (previous[key].average / adjustedTotals['previous']);
      }
      _changes.push({name: key, didChange: true, changeType: changeType, change: change, changePercent: changePercent, adjustedPercent: adjustedPercent});
      delete current[key]; //we delete so we can then find what keys were not included in the previous
    }else{
      _changes.push({name: key, didChange: false, previous: true, change: previous[key].average, changePercent: 0, adjustedPercent: 0});
    }
  }
  for(var key in current){
    totalInCurrent += current[key].average;
    _changes.push({name: key, didChange: false, previous: false, change: current[key].average, changePercent: 0, adjustedPercent: 0});
  }

  _changes.forEach(function(d){
    if(d.changeType == 'same' || (!d.didChange && !d.previous)){
      d.changePercent = (d.change / totalInCurrent) * 100;
    }
  });
  return _changes;
}

function isNumeric(n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
}

function flattenArray(arr) {
  return arr.reduce(function (flat, toFlatten) {
    return flat.concat(Array.isArray(toFlatten) ? flattenArray(toFlatten) : toFlatten);
  }, []);
};

function padDate(n){
	return (n<10 ? '0'+n : n);
}

function applySentenceCase(str) {
    return str.replace(/.+?[\.\?\!](\s|$)/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
}

function getClockTime(date){
   var hour   = date.getHours();
   var minute = date.getMinutes();
   var ap = "AM";
   if (hour   > 11) { ap = "PM";             }
   if (hour   > 12) { hour = hour - 12;      }
   if (hour   == 0) { hour = 12;             }
   if (hour   < 10) { hour   = "0" + hour;   }
   if (minute < 10) { minute = "0" + minute; }
   var timeString = hour + ':' + minute + " " + ap;
   return timeString;
}

function fixName(name){
  if(name == 'HMO'){
    return name;
  }
  try{
	 return name.replace(/\w\S*/g, function(word){return word.charAt(0).toUpperCase() + word.substr(1).toLowerCase();});
  }catch(err){
    return name;
  }
}

function monthDiff(d1, d2) {
    var months;
    months = (d2.getFullYear() - d1.getFullYear()) * 12;
    months -= d1.getMonth() + 1;
    months += d2.getMonth();
    months += 2;
    return months <= 0 ? 0 : months;
}

function getAllGroupData(chart){
    var returnData = [];
    chart.allGroups().forEach(function(d){
      d.all().forEach(function(a){
        returnData.push(a);
      })
    });
    return returnData;
}

function popUpBlock(html, small) {
  if(typeof small == undefined){small = false;}
  if(small){
    $('body').prepend('<div class="pop_up border-box tan" style="z-index: 1000001 !important; text-align:left; top: 45%; width: 300px; margin-left: -150px;"><p style="text-align:left;font-size:125%;">' + html + '</div><div class="overlay"></div>');
  }else{
    $('body').prepend('<div class="pop_up border-box" style="z-index: 1000001 !important; text-align:left; top: 8%; width: 600px; margin-left: -300px;"><p style="text-align:left;font-size:125%;">' + html + '</div><div class="overlay"></div>');
  }
  $('#msgClose').click(function() {
    removePopUpAndOverlay();
  });
}

function removeRepeatNames(d, layerToUse, objectToUse){
  objectToUse = (objectToUse == undefined ? 'id' : objectToUse);
  layerToUse = (layerToUse == undefined ? 'all' : layerToUse);

  var things;
  if(layerToUse !== false){
    things = d[layerToUse];
  }else{
    things = d;
  }
  var arr = {};

  for ( var i=0, len=things.length; i < len; i++){
      arr[things[i][objectToUse]] = things[i];
  }

  things = new Array();
  for ( var key in arr ){
      things.push(arr[key]);
  }
  return things;
}

function getMonthsBetweenDates(from, to) {
    var arr = [];
    var datFrom = new Date('1 ' + from);
    var datTo = new Date('1 ' + to);
    var fromYear =  datFrom.getFullYear();
    var toYear =  datTo.getFullYear();
    var diffYear = (12 * (toYear - fromYear)) + datTo.getMonth();

    for (var i = datFrom.getMonth(); i <= diffYear; i++) {
        arr.push(getMonthName(i%12) + " " + Math.floor(fromYear+(i/12)));
    }

    return arr;
}

function getMonthName(month){
  switch(month){
    case 0:
      return 'January';
      break;
    case 1:
      return 'February';
      break;
    case 2:
      return 'March';
      break;
    case 3:
      return 'April';
      break;
    case 4:
      return 'May';
      break;
    case 5:
      return 'June';
      break;
    case 6:
      return 'July';
      break;
    case 7:
      return 'August';
      break;
    case 8:
      return 'September';
      break;
    case 9:
      return 'October';
      break;
    case 10:
      return 'November';
      break;
    case 11:
      return 'December';
      break;
    default:
      break;
  }
}

function inRange(x, min, max) {
    return min <= x && x <= max;
}

function riskAdjustedRate(OBS, EXP, NAT){
  var OBS = OBS / (1 - OBS);
  var EXP = EXP / (1 - EXP);
  var NAT = NAT / (1 - NAT);
  //product rule
  var exponent = (1 / OBS)*(EXP/NAT);
  var denominator = 1 + Math.exp(Math.log(exponent));
  result = 1 / denominator;
  return result;
}

function isWithinTimeRange(date, overwriteFrom){
  var withinMonth = d3.time.day(date);
  var to = $('#to').datepicker('getDate');
  var from = (overwriteFrom === undefined ? $('#from').datepicker('getDate') : overwriteFrom);
  if(withinMonth > to || from > withinMonth){
    return false;
  }else{
    return true;
  }
}

function daysInMonth(m, y) {
   return /8|3|5|10/.test(--m)?30:m==1?(!(y%4)&&y%100)||!(y%400)?29:28:31;
}

function daydiff(first, second) {
    return Math.abs(Math.round((second-first)/(1000*60*60*24)));
}

function isBlank(str) {
    return (!str || /^\s*$/.test(str));
}

function getActiveSimpleFilter(data){
  for(var i = 0; i < data.length; i++){
    if(data[i].selected){
      return data[i].key;
    }
  }
}

d3.selection.prototype.last = function() {
  var last = this.size() - 1;
  return d3.select(this[0][last]);
};

function popUpMsg(msg, wide) {
   if (typeof wide === 'undefined') { wide = false; }

   $('body').prepend('<div class="pop_up tan '+(wide ? 'wider' : '')+'" style="z-index: 19999999 !important;"><p style="text-align:left;font-size:125%;"><i id="msgClose" class="icon-cancel-circled" data-icon="i" style="float:right;margin:0 0 0 10px;font-size:26px;max-height:26px;overflow:hidden"></i>' + msg + '</p></div><div class="overlay" style="z-index: 10 !important;"></div>');

   $('#msgClose').click(function() {
      var pop = $(this).closest('.pop_up');
      var overlay = $(pop).next('.overlay');
      $(pop).remove();
      $(overlay).remove();
   });
}

function setUpDatepickers(){
   var lastMonth = new Date();
   lastMonth.setMonth(lastMonth.getMonth() - 1);
   lastMonth = new Date(lastMonth.getFullYear(), lastMonth.getMonth() + 1, 0);
   var thirtyDays = new Date(lastMonth.getFullYear(), lastMonth.getMonth(), 1);

   $( "#from" ).datepicker({
      changeMonth: true,
      dateFormat: 'mm-dd-yy',
      onClose: function( selectedDate ) {
         $( "#to" ).datepicker( "option", "minDate", selectedDate );
      }
   });
   $( "#from" ).datepicker("setDate", thirtyDays);
   $( "#to" ).datepicker({
      dateFormat: 'mm-dd-yy',
      changeMonth: true,
      onClose: function( selectedDate ) {
         $( "#from" ).datepicker( "option", "maxDate", selectedDate );
      }
   });
   $( "#to" ).datepicker("setDate", lastMonth);
}

function checkifMobile(){
  var check = false;
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4)))check = true})(navigator.userAgent||navigator.vendor||window.opera);
  return check;
}

function popovers() {
  if(!checkifMobile){
    return;
  }
  $('.showRegPop').hover(
    function() {
      var that = $(this);
      var defPop;
      if($(that).attr('data-isInner') !== undefined && $(that).attr('data-isInner') == 'true' && $(that).next('.defPop').length == 0){
        defPop = $('<div class="defPop halfwidth"><div class="onlyRelWrap"><span class="indicator_desc_close"><i class="icon-cancel-circled" data-icon="i"></i></span><span class="pop-content"><p style="text-align:center;"><img src="/images/ajax-loader-oj-on-white.gif" /></p></span></div></div>').insertAfter($(that));
      }else{
        defPop = $(that).next('.defPop');
      }
      $(defPop).css({'left': '-3px'});
      $(defPop).css('display','block').stop().animate({'opacity':1},300);
      if($(that).attr('rel') != 'static'){
        $.post('_includes/indicators-ajax.php',{ action : 'loadIndDesc', ind_uid : $(this).attr('rel') } , function(html) {

          $('.ind_content_' + $(that).attr('rel')).html(html);

          $('.ind_content_' + $(that).attr('rel') + ' img').each(function() {
            $(this).attr('src', '<?php echo SITE_URL; ?>' + $(this).attr('src'));
          });

          var height = $(defPop).height() + $(that).height() + 6 + 16;

          $(that).next('.defPop').css('top', '-'+height+'px');

        }, 'html');
      }else{
        $(defPop).find('.pop-content').empty().html($(that).data('content'));
        $(defPop).css({'top': 'auto'});
        if($(that).attr('data-isInner') == 'true'){
            $(defPop).css('left', '-1px');
        }else{
          if(!$(defPop).isOnScreen()){
            $(defPop).css({'left': 'auto', 'right': '-1px'});
          }else if($(defPop).isOnScreen()){
            $(defPop).css({'left': '-1px', 'right': 'auto'});
          }
        }
      }
    },

    function() {
      var defPop = $(this).next('.defPop');
      $(defPop).stop().animate({'opacity':0},300,function() { $(defPop).css({'left': 'auto', 'right': 'auto'}); $(defPop).css('display','none'); });
    }

  );

  $('.topRight, .indicator_desc_close').click(function() {
    $(this).parent().parent().stop().animate({'opacity':0},300,function() { $(this).css({'left': 'auto', 'right': 'auto'}); $(this).css('display','none'); });
  });
}